// Measure the real masthead so the opening scene fills the remaining viewport.
(() => {
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const measure = () => document.body.style.setProperty('--web-header', `${header.getBoundingClientRect().height}px`);
    measure();
    new ResizeObserver(measure).observe(header);
  }

  // Animate the updated reading only; state, focus and native navigation remain immediate.
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Map();
  let keyboard = false;
  document.addEventListener('keydown', () => { keyboard = true; }, { passive: true });
  document.addEventListener('pointerdown', () => { keyboard = false; }, { passive: true });
  const reveal = (element) => {
    running.get(element)?.cancel();
    if (reducedMotion.matches || keyboard || element.hidden || !element.getClientRects().length) return;
    const animation = element.animate([{ opacity: .45 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
    running.set(element, animation);
    animation.onfinish = () => running.delete(element);
    animation.oncancel = () => { if (running.get(element) === animation) running.delete(element); };
  };
  const panels = document.querySelectorAll('main [role="tabpanel"], main [data-library-panel], main [data-crossroads-panel], main [data-tool-panel]');
  const panelObserver = new MutationObserver((records) => {
    for (const element of new Set(records.map(record => record.target))) reveal(element);
  });
  panels.forEach(panel => panelObserver.observe(panel, { attributes: true, attributeFilter: ['hidden'] }));
  const copy = document.querySelector('.planet-copy');
  if (copy) new MutationObserver(() => reveal(copy)).observe(copy, { childList: true, subtree: true, characterData: true });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) { running.forEach(animation => animation.cancel()); running.clear(); }
  });
})();
